import React from 'react';

import Storage from './components/Storage';
import Trello from './components/Trello';
import Page from './components/Page';

function App() {
  return (
    <Storage session="cards" name="trello-cards">
      <Trello>
        <Page />
      </Trello>
    </Storage>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js